import { useCallback } from 'react';
import type { Product } from '@/lib/types';

export function useDataMerge() {
  const mergeCopyOntoProducts = useCallback((prods: Product[], copyRows: any[]) => {
    if (!copyRows || copyRows.length === 0) return prods;
    const copyByProduct: Record<string | number, Record<string, any>> = {};
    for (const row of copyRows) {
      const pid = row.product_id;
      if (!copyByProduct[pid]) copyByProduct[pid] = {};
      copyByProduct[pid][row.channel] = {
        title: row.title || "",
        bullets: row.bullets || [],
        description: row.description || "",
        backendKeywords: row.backend_keywords || "",
        approvedAt: row.approved_at || "",
        approvedBy: row.approved_by || "",
      };
    }
    return prods.map(p => {
      const normalizedCopy = p.id != null ? copyByProduct[String(p.id)] : undefined;
      if (normalizedCopy) {
        return { ...p, approvedCopy: { ...(p.approvedCopy || {}), ...normalizedCopy } };
      }
      return p;
    });
  }, []);

  const mergeArtDirectionOntoProducts = useCallback((prods: Product[], adRows: any[]) => {
    if (!adRows || adRows.length === 0) return prods;
    const adByProduct: Record<string, any> = {};
    for (const row of adRows) {
      adByProduct[String(row.product_id)] = {
        images: row.images || [],
        generatedImages: row.generated_images || {},
        savedAt: row.saved_at || null,
      };
    }
    return prods.map(p => {
      const normalized = p.id != null ? adByProduct[String(p.id)] : undefined;
      if (normalized) {
        return { ...p, artDirection: { ...(p.artDirection || {}), ...normalized } };
      }
      return p;
    });
  }, []);

  return { mergeCopyOntoProducts, mergeArtDirectionOntoProducts };
}
